import React, { useState } from 'react';

import ReactDOM from 'react-dom';
import { useForm } from "react-hook-form";

//class Form1 extends React.Component {
//  constructor() {
//    super();
//  }
//  render() {
//    <h1>¿No encuentras tu pregunta?</h1>
//    return (
//      <form/* onSubmit={handleSubmit(onSubmit)}*/>
//        <input name="email" label="Email" /* ref={register}*/ />
//        <select name="gender"/* ref={register}*/>
//          <option value="male">male</option>
//          <option value="female">female</option>
//        </select>
//        <textarea/* ref={register}*/ />
//        <input type="submit" />
//      </form>
//    )
//  }
//}
//
//if (document.getElementById('form-1'))
//ReactDOM.render(<Form1 />, document.getElementById('form-1'));

  
function SampleForm() {
  const { register, handleSubmit, watch, errors } = useForm();//useForm<Inputs>() peta

  let [emailMessage, setEmailMessage] = useState('');
  let [isLoading, setisLoading] = useState(false);

  const onLoad = () => {
    setTimeout(() => {
      $("*").each(function () {
        if (kn_translation) {
          if (kn_translation[$(this).attr('for')]) $(this).html(kn_translation[$(this).attr('for')]);
          if (kn_translation[$(this).data('trans')]) $(this).html(kn_translation[$(this).data('trans')]);
          if (kn_translation[$(this).attr('value')]) $(this).html(kn_translation[$(this).attr('value')]);
          if ($(this).data('trans') === "terms_and_conditions") $(this).attr("href", kn_variables.privacy_url);
        }
      })
    }, 1)
  };

  const onSubmit = data => {

    setisLoading(true);

    $.ajax({
      method: "POST",
      data: data,
      url: kn_variables.template_url + '/blocks/forms/form-1/form-1-backend.php'
    }).then(res => {
      const result = JSON.parse(res);

      // if success { message: 'your mail has been sent', success: true }
      // if failed { message: 'there was an error', success: false }

      setEmailMessage(result);
      setisLoading(false);

      if (kn_form_1 && kn_form_1.success_url && kn_form_1.success_url.url)
        window.location.href = kn_form_1.success_url.url + window.location.search;

    });
  };

  return (
    <div className="App">
      <form onLoad={onLoad()} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label htmlFor="email" class="input-label">Email</label>
          <input name="email" id="email" placeholder="" type="email" ref={register({ required: true, maxLength:50, pattern: {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: "invalid email address"} })} />
          {errors.email && errors.comment.type === "required" && <span class="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="comment" class="input-label">Message</label>
          <textarea name="comment" id="comment" rows="12" placeholder="" ref={register({ required: true, maxLength: 400 })} />
          {errors.comment && errors.comment.type === "required" && <span class="field-required">*Required</span>}
          {errors.comment && errors.comment.type === "maxLength" && <span class="field-required">*400 characters maximum</span> }
        </div>
        
        <div>
          <label class="accept-label">
            <input name="accept" id="accept" type="checkbox" ref={register({ required: true })}/>
            <span data-trans="iaccept">I Accept the</span> <a href="#" class="form-link" data-trans="terms_and_conditions">terms and conditions</a>
          </label>
        </div>

        <div id="submit-div">
          <button type="submit" id="submit" data-trans="send" class="kn-button-1 secondary animated fade-in-bottom">Send</button>
        </div>

      </form>
    </div>
  );
}

class Form1 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <SampleForm />;
  }
}

const form1Div = document.getElementById('form-1');
ReactDOM.render(<Form1 />, form1Div);